import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin'

gsap.registerPlugin(SplitText, ScrollTrigger, ScrambleTextPlugin)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  matrix() {
    gsap.to(this.el, {
      opacity: 1,
      duration: 1,
    })

    const tl = gsap.timeline({
      onStart: () => {},
    })
    const split = new SplitText(this.el, { type: 'words,chars' })
    const { chars } = split

    gsap.set(this.el, { perspective: 400 })
    tl.from(chars, {
      scale: 0,
      y: 80,
      rotationX: 180,
      transformOrigin: '0% 30% -30',
      ease: 'back',
      stagger: 0.01,
      duration: 1.4,
      delay: 0.25,
    })
    tl.to(
      this.el,
      {
        duration: 1,
        opacity: 1,
      },
      0.6,
    )

    const services = document.querySelector('#services')
    let scrubAnimationEnabled = false
    const scrubAnimation = () => {
      if (scrubAnimationEnabled) return
      scrubAnimationEnabled = true

      gsap.killTweensOf(this.el)
      gsap.set(this.el, { clearProps: 'all' })
      const revertedTimeline = gsap.timeline()
      revertedTimeline.to(chars, {
        scale: 0,
        y: 60,
        rotationX: 180,
        transformOrigin: '0% 30% -30',
        ease: 'back',
        stagger: 0.01,
        duration: 1.4,
        delay: 0.25,
      })
      revertedTimeline.from(
        this.el,
        {
          duration: 1,
          opacity: 1,
        },
        0.6,
      )

      const offset = window.innerHeight / 3
      ScrollTrigger.create({
        animation: revertedTimeline,
        trigger: services,
        start: '50% 40%',
        end: () => `bottom+=${offset} top`,
        scrub: 1,
        // markers: true,
      })
    }

    ScrollTrigger.create({
      trigger: services,
      start: '75% top',
      once: true,
      onEnter: () => {
        scrubAnimation()
      },
      // onLeave: () => {
      //   console.log('onLeave')
      //   // scrubAnimation()
      // },
      // onEnterBack: () => {
      //   console.log('onEnterBack')
      //   // scrubAnimation()
      // },
      // onLeaveBack: () => {
      //   console.log('onLeaveBack')
      //   // scrubAnimation()
      // },
    })
  }

  scrambler() {
    const items = this.el.querySelectorAll('button, a')
    items.forEach((item) => {
      const text = item.textContent.trim()
      const tl = gsap.timeline({ paused: true })
      tl.to(item, {
        scrambleText: {
          text,
          chars: 'XO',
        },
      })

      item.addEventListener('mouseenter', () => {
        if (window.innerWidth < 768) return
        tl.restart()
      })
    })
  }

  rainfall() {
    this.children = this.el.children

    const H2 = document.querySelector('.services')
    this.nestedChildren = [this.el.querySelectorAll('.nested')]

    const main = gsap.timeline()
    main.to(this.children, {
      opacity: 1,
      stagger: {
        amount: 0.5,
      },
      duration: 1,
      delay: 1.5,
    })
    main.to(
      H2,
      {
        opacity: 1,
        duration: 1,
      },
      2,
    )

    const nested = gsap.timeline()
    nested.to(this.nestedChildren, {
      opacity: 0,
      stagger: {
        amount: 0.5,
      },
      duration: 1,
    })

    const section = document.querySelector('#services')
    ScrollTrigger.create({
      animation: nested,
      trigger: section,
      start: '50% top',
      scrub: 1,
    })
  }

  grain() {
    const grain = document.querySelector('.grain')
    const canvas = document.querySelector('[data-module-canvas]')

    ScrollTrigger.create({
      trigger: this.el,
      start: 'top 50%',
      onEnter: () => {
        grain.classList.add('active')
        canvas.classList.add('opacity-10')
        document.dispatchEvent(new CustomEvent('grain', { detail: { active: true } }))
      },
      onLeaveBack: () => {
        grain.classList.remove('active')
        canvas.classList.remove('opacity-10')
        document.dispatchEvent(new CustomEvent('grain', { detail: { active: false } }))
      },
    })
  }

  sub() {
    const input = document.querySelector('[data-footer-input]')
    const split = new SplitText(this.el, { type: 'chars' })
    const { chars } = split

    gsap.set(this.el, { perspective: 400 })
    const animation = gsap.timeline()
    animation.from(chars, {
      scale: 0,
      y: 80,
      rotationX: 90,
      transformOrigin: '0% 30% -30',
      ease: 'back',
      stagger: 0.01,
      duration: 1.4,
      delay: 0.25,
    })
    animation.from(
      input,
      {
        y: 80,
        duration: 1,
      },
      '-=1.4',
    )

    const trigger = document.querySelector('#blog')
    ScrollTrigger.create({
      animation,
      trigger,
      start: 'start bottom',
      end: 'bottom bottom',
      // markers: true,
      scrub: 1,
    })
  }

  footer() {
    const about = document.querySelector('[data-footer-about]')
    const text = about.textContent.trim()
    const tl1 = gsap.timeline()
    tl1.to(about, {
      scrambleText: {
        text,
        chars: 'XO ',
        tweenLength: true,
      },
    })
    ScrollTrigger.create({
      animation: tl1,
      trigger: this.el,
      start: 'start 90%',
      end: 'max',
      scrub: 1,
    })

    const h2 = this.el.querySelector('h2')
    const p = this.el.querySelector('p')
    const links = this.el.querySelectorAll('a')
    const tl2 = gsap.timeline()
    tl2.from(h2, {
      opacity: 0,
    })
    tl2.from(p, {
      opacity: 0,
    })
    tl2.from(links, {
      opacity: 0,
      stagger: 0.1,
    })

    ScrollTrigger.create({
      animation: tl2,
      trigger: this.el,
      start: 'start 90%',
      end: 'max',
      scrub: 1,
    })
  }
}
